import {
  Navigate,
  Outlet,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";

import {
  TextsProvider,
  CompareProvider,
} from "../providers";

import { PATH_ROUTES } from "./routes";

import { Home, ProfessionsRegulades, ProfessionalsSanitaris, OfertaUniversitaria, DesajustTitulacio, Login } from "../pages";

import ProtectedRoute from "./ProtectedRoute";

const routes = createBrowserRouter([
  {
    path: PATH_ROUTES.login,
    element: <Login />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: PATH_ROUTES.home,
        element: (
          <TextsProvider>
            <CompareProvider>
              <Outlet />
            </CompareProvider>
          </TextsProvider>
        ),
        children: [
          {
            index: true,
            element: <Navigate to={PATH_ROUTES.titulacions} replace />,
          },
          {
            path: "titulacions",
            element: <Home />,
          },
          {
            path: "professions-regulades",
            element: (
              <ProfessionsRegulades />
            ),
          },
          {
            path: "professionals-sanitaris",
            element: (
              <ProfessionalsSanitaris />
            ),
          },
          {
            path: "oferta-universitaria",
            element: (
              <OfertaUniversitaria />
            ),
          },
          {
            path: "desajust-titulacio",
            element: (
              <DesajustTitulacio />
            ),
          },
        ],
      }
    ],
  },
  { path: "*", element: <Navigate to={PATH_ROUTES.titulacions} /> }, // Si no es una ruta correcta redirigimos a Titulacions
]);

const Router = () => {
  return <RouterProvider router={routes} />;
};

export default Router;
